import { render } from "./DescriptionContainer.vue?vue&type=template&id=09cf51cc"
import script from "./DescriptionContainer.vue?vue&type=script&lang=js"
export * from "./DescriptionContainer.vue?vue&type=script&lang=js"

import "./DescriptionContainer.vue?vue&type=style&index=0&id=09cf51cc&lang=scss"

import exportComponent from "/opt/build/repo/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__